import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { SidenavService } from './sidenav/sidenav.service';
import { LayoutService } from './layout.service';
import { environment } from '../../environments/environment';
import { ApiService } from '../services/base/api.service';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'fury-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {

  sidenavOpen$: Observable<boolean> = this.sidenavService.open$;
  sidenavMode$: Observable<'side' | 'over'> = this.sidenavService.mode$;

  public isStaging: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private sidenavService: SidenavService,
              public api: ApiService,
              public layoutService: LayoutService,
  ) {
  }

  ngOnInit(): void {
    if (environment.appVersionAddon === '-staging') {
      this.isStaging = true;
      this.renderer.addClass(this.document.body, 'is-staging');
    }
  }

  closeSidenav(): void {
    this.sidenavService.close();
  }

  openSidenav(): void {
    this.sidenavService.open();
  }

  ngOnDestroy(): void {
  }
}

